// ─────────────────────────────────────────────────────────────────────────────
// BackChevron — top-left `<` back button shown on every authenticated screen
// except the homepage (Chunk 6, spec §10).
//
// UI state only (Ghost Flag 10): pressing it flips `screen` one level. It does
// NOT call handleDomainChange or handleAgentChange. activeDomain / activeAgent
// and the backend session they represent are preserved across back navigation.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { REXY_FONT, REXY_CONSOLE } from '../../lib/rexyConsole';

export interface BackChevronProps {
  onPress: () => void;
}

export default function BackChevron({ onPress }: BackChevronProps) {
  return (
    <button type="button" onClick={onPress} aria-label="Back" style={btnStyle}>
      ‹
    </button>
  );
}

const btnStyle: React.CSSProperties = {
  position: 'fixed',
  top: 14,
  left: 14,
  width: 36,
  height: 36,
  borderRadius: 18,
  background: 'rgba(8,8,24,0.6)',
  border: `1px solid ${REXY_CONSOLE.cardBorder}`,
  color: REXY_CONSOLE.primary,
  fontSize: 22,
  lineHeight: '32px',
  textAlign: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  zIndex: 10,
  fontFamily: REXY_FONT,
  padding: 0,
};
